module.exports = __webpack_public_path__ + "static/media/liqSueldo.1fdc7e9b.svg";